<template>
  <div>

      <div class="block" >
          <div class="block-header bg-gray-lighter">
              <ul class="block-options">
                  <li>
                      <button type="button" data-toggle="block-option" data-action="fullscreen_toggle"></button>
                  </li>
                  <li>
                      <button type="button" @click="readJournalReadings()" data-toggle="block-option" data-action="refresh_toggle" data-action-mode="demo"><i class="si si-refresh"></i></button>
                  </li>
              </ul>
              <h3 class="block-title"><i class="fa fa-list-alt"></i> {{ sectionLabelLogBook[actualLanguage] }}</h3>
          </div>

          <div class="block-content" style="overflow-y:scroll; height:400px;">
          <div v-if = "totalWorkingTime > 0" class="block-content">
            <h5><i class="fa fa-wrench fa-1x text-warning"></i> {{textLableTotalMaintenance[actualLanguage] }} {{totalWorkingTime}} Hr</h5>
          </div>


            <div class="block-content">
                <ul class="list list-activity push">

                    <li v-for="(logItem,index) in journalItems">
                        <i v-if="logItem.event_type==='Alert'" class="fa fa-bell text-danger"></i>
                        <i v-if="logItem.event_type==='comment'" class="fa fa-comment text-info"></i>
                        <i v-if="logItem.event_type==='maintenance'" class="fa fa-wrench text-warning"></i>

                        <div class="font-w600">{{logItem.timestamp_local.substr(0,16)}}</div>
                        <div><a>{{logItem.event_info.postedBy}}</a></div>

                        <div v-if="logItem.event_type==='comment'"><small class="text-muted">{{logItem.event_info.comment}}</small></div>

                        <div class="font-w600" v-if="logItem.event_type==='maintenance'"><small class="text-muted">Travail: {{logItem.event_info.workTime}} Hr</small></div>
                        <div v-if="logItem.event_type==='maintenance'"><small class="text-muted">{{logItem.event_info.description}}</small></div>

                        <div v-if="logItem.event_type==='Alert'"><small class="text-muted">{{logItem.event_info.description}}</small></div>

                    </li>

                </ul>
            </div>

          </div>



        <div class="col-xs-12 col-sm-12">

          <div class="col-sm-12 col-md-6">
            <button type="button" @click="addChannelCommentLog()" class="btn btn-success" ><i class="fa fa-comment fa-1x push-5-r "></i>{{buttonAddComment[actualLanguage] }}</button>
          </div>
          <div class="col-sm-12 col-md-6">
            <button type="button" @click="addChannelMaintenanceLog()" class="btn btn-success" ><i class="fa fa-wrench fa-1x push-5-r "></i>{{buttonAddMaintenance[actualLanguage] }}</button>
          </div>

        </div>

      </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import PortGraph from './PortGraph.vue'
//import ChannelCommentAddForm from './ChannelCommentAddForm.vue'

export default {
  props: ['channelIndex'],
  components: {
    PortGraph,
  },
  data() {
    return {
      timeRange : 0,
      journalItems : [],
      totalWorkingTime : 0,

      actualLanguage : "FR",

      sectionLabelLogBook:{FR: "Journal de l'appareil", EN: 'Device log book'},
      textLableTotalMaintenance:{FR: "Temps maintenance total:", EN: 'Total maintenance work time:'},
      buttonAddComment:{FR: "Ajouter un commentaire", EN: 'Add comment'},
      buttonAddMaintenance:{FR: "Ajouter un entretient", EN: 'Add maintenance'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  watch: {
    startDate(){

        //console.log('---ChannelJournal: Start Date Watcher-----')
        //console.log(this.startDate)

    },

    overlayParameters(){
      //console.log('---Journal overlayParameter trig')

      this.$nextTick(() => {
          this.readJournalReadings()
        });
      
    },
  },


  methods: {
      ...mapActions('overlayStore', ['showModal']),

      computeTimeRange(){
            this.timeRange = this.endDate - this.startDate
          },

      addChannelCommentLog(){
        var parameters = {'channelIndex':this.channelIndex}
        this.$store.dispatch('overlayStore/setParameters',parameters)
        this.showModal('channel-comment-add-form')
        this.readJournalReadings()
      },

      addChannelMaintenanceLog(){
        var parameters = {'channelIndex':this.channelIndex}
        this.$store.dispatch('overlayStore/setParameters',parameters)
        this.showModal('channel-maintenance-add-form')
        this.readJournalReadings()
      },


    readJournalReadings(){
        //Ce call effectue une mutation de actualBundle, l'affichage sera donc activé par le watcher
        //de actualBundle.
        this.flagChannelDataIsLoading = true
        //console.log(this.actualBundle.bundle_id)
        //'end':moment().unix(),
        //console.log(this.startDate)
        //console.log(this.endDate)
        var requestData = { 'postAction':'GetChannelJournalLog',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelId':this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                            'start':this.startDate,
                            'end':this.endDate,
                            }

        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
              //console.log(response.data)
            if(response.data.Code=='OK'){
                this.journalItems = response.data.journalItems

                this.totalWorkingTime = 0
                for (var n = 0; n < this.journalItems.length; n++) {
                    if(this.journalItems[n].event_type=='maintenance'){
                        this.totalWorkingTime += parseFloat(this.journalItems[n].event_info.workTime)
                    }
                  }

                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            }) 
      },

    },

  mounted() {
    this.computeTimeRange()
    this.readJournalReadings()
    //console.log(this.startDate)
    //console.log(this.endDate)
    //console.log(moment().unix())

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

  },



}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// ChannelJournal.vue?65d4bf0f